





























































import { Component, Prop, Vue } from "vue-property-decorator";
import { BNavItemDropdown, BDropdownItem, BPopover } from "bootstrap-vue";

@Component({
    components: {
        BNavItemDropdown,
        BDropdownItem,
        BPopover,
    },
    filters: {
        size: function (bytes: number) {
            if (bytes === 0) return '0 Bytes';
            const decimals: number = 2;

            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];

        }
    },
})
export default class FileList extends Vue {
    @Prop(Array) readonly items!: Array<any>;
}
